<template>
  <StSelect
    v-model="selectedOption"
    class="select-filter"
    :placeholder="t('casino.sort')"
    :items="sortOptions"
    size="s"
    icon-prefix="filter-solid"
    data-t="select-sort"
  />
</template>

<script setup lang="ts">
const { t } = useI18n()

const selectedOption = defineModel<string>({ required: true })

const { sortOptions } = useSelectSorting()
</script>

<style scoped>
.select-filter {
  min-width: 160px;
}
</style>
